import React from 'react'
import ArrowForwardIosTwoToneIcon from '@material-ui/icons/ArrowForwardIosTwoTone';
import coverLetter from './CoverLetter'
import './Resume.css'
import {Link} from 'react-router-dom'
function Resume() {

  return (
    <html>

  <head>

  </head>
  <body>



<div>

  <div className="resume">
    <h2 className="">My Resume</h2>
    <img className="Resume_img" src="https://raw.githubusercontent.com/harshitagrawal7733/Resume/main/Resume.png"/>

  </div>
  <div className="button_arrow">
<Link to="coverLetter">
<ArrowForwardIosTwoToneIcon/>
</Link>
  </div>
  </div>
  </body>
  </html>
  )
}

export default Resume;
